export default __webpack_public_path__ + "static/media/cert6.88158d63.jpg";